// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FilterFilledSvg from "@ant-design/icons-svg/es/asn/FilterFilled";
import AntdIcon from '../components/AntdIcon';

var FilterFilled = function FilterFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FilterFilledSvg
  }));
};

FilterFilled.displayName = 'FilterFilled';
export default React.forwardRef(FilterFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/FilterFilled.js
// module id = 1169
// module chunks = 0